<template>
  <div id="publicPage">
    <AppHeader></AppHeader>
    <div class="content mainSection" v-if="isLisbergSite">
      <h1 v-html="$t('publicPage.header_lisberg')"></h1>
      <div v-html="$t('publicPage.content_lisberg')"></div>
    </div>
    <div class="content mainSection" v-else>
      <h1>{{ $t('publicPage.header') }}</h1>
      <div v-html="$t('publicPage.content')"></div>
    </div>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppHeader from '../components/appheader'
import AppFooter from '../components/appfooter'
import { mapGetters } from 'vuex'

export default {
  name: 'PublicPage',
  components: {
    AppHeader,
    AppFooter
  },
  computed: {
    ...mapGetters(['isLisbergSite'])
  }
}
</script>

<style scoped>

</style>
